/**
 * Header component for dashboard
 * Shows mobile menu toggle, author info, and logout button
 */
import { useAuth } from "./AuthProvider";

// ---------------------------------------------------------------------------
// Icons
// ---------------------------------------------------------------------------

function MenuIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

// ---------------------------------------------------------------------------
// Header Component
// ---------------------------------------------------------------------------

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { user, logout } = useAuth();

  return (
    <header className="h-16 bg-white border-b border-slate-200 px-4 flex items-center justify-between">
      {/* Left: Mobile menu toggle */}
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="p-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-md lg:hidden"
          aria-label="Toggle menu"
        >
          <MenuIcon />
        </button>
        <h1 className="text-lg font-semibold text-slate-900 hidden sm:block">
          Author Dashboard
        </h1>
      </div>

      {/* Right: User info + logout */}
      <div className="flex items-center gap-4">
        <span className="text-sm text-slate-600 hidden sm:block">
          {user?.name || user?.email}
        </span>
        <button
          onClick={logout}
          className="px-3 py-1.5 text-sm text-slate-600 border border-slate-300 rounded-md hover:bg-slate-100 transition-colors"
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
